var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 18.8332C15.4357 18.8332 19.1667 15.1022 19.1667 10.4998C19.1667 5.8975 15.4357 2.1665 10.8333 2.1665C6.231 2.1665 2.5 5.89742 2.5 10.4998C2.5 15.1023 6.231 18.8332 10.8333 18.8332ZM7.74417 9.91067C8.06967 9.58517 8.597 9.58517 8.92258 9.91067L10.0001 10.9882L12.7443 8.244C13.0698 7.9185 13.5971 7.9185 13.9227 8.244C14.2483 8.5695 14.2482 9.09684 13.9227 9.42242L10.5893 12.7558C10.4266 12.9185 10.2133 12.9999 10.0002 12.9999C9.787 12.9999 9.57375 12.9185 9.411 12.7558L7.74433 11.0891C7.41883 10.7636 7.41867 10.2363 7.74417 9.91067Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.f6ff8d2b301ca0e83ec22962a20e1400.svg";
export { ForwardRef as ReactComponent };